import React from 'react'
import { Input, Label, Dropdown as UnstyledDropdown } from 'semantic-ui-react'
import styled from 'styled-components'
import { InputWrapper } from './index'
import constants from 'config/constants'

// PET-1965: match both metric selectors to the disabled QuestionTypeField so the
// metric card's fields read uniformly. Flag-on only — legacy keeps its own look.
// - editable: grey background + text colour on the dropdown.
// - disabled: force opacity to 1 (Semantic fades `.ui.disabled.input` to 0.45,
//   which washed out the grey vs the full-opacity QuestionTypeField).
const MatchedDropdown = styled(UnstyledDropdown)`
  &.ui.selection.dropdown {
    background: rgba(244, 244, 244, 0.8);
    color: #373f46;
  }
  & > .text {
    color: #373f46;
  }
`

// Based on Input (not InputWrapper) to avoid a circular-import cycle with
// ./index — styled() runs at module load, before InputWrapper is defined.
const MatchedInput = styled(Input)`
  &.ui.input.labeled input[disabled] {
    background: rgba(244, 244, 244, 0.8);
    color: #373f46;
    opacity: 1;
  }
  &.ui.disabled.input {
    opacity: 1;
  }
`

const metricTitle = {
  CSAT: constants.questionMetricTitle.CSAT,
  NPS: constants.questionMetricTitle.NPS,
  CES: constants.questionMetricTitle.CES,
  '5-STAR': constants.questionMetricTitle.star,
}

export default function PrimaryQuestionMetricInput({
  canChangePrimaryMetric,
  matchFieldStyle,
  metric,
  handleMetricChange,
  hackLabeledDropdownStyle,
  primaryMetricDropdownOptions,
}) {
  if (canChangePrimaryMetric) {
    const Dropdown = matchFieldStyle ? MatchedDropdown : UnstyledDropdown
    return (
      <Input data-testid="primary-metric" className="labeled large">
        <Label color="blue">{metric}</Label>
        <Dropdown
          selection
          fluid
          defaultValue={metric}
          style={hackLabeledDropdownStyle}
          options={primaryMetricDropdownOptions}
          onChange={handleMetricChange}
        />
      </Input>
    )
  }

  const title = metricTitle[metric]
  if (!title) {
    return null
  }

  const ReadOnlyInput = matchFieldStyle ? MatchedInput : InputWrapper
  return (
    <ReadOnlyInput
      data-testid="primary-metric"
      className="labeled large"
      value={title}
      disabled
    />
  )
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/organisms/PrimaryQuestionInput/PrimaryQuestionMetricInput.js